/**
 * Highlights search matches in HTML content
 * @param html - The HTML content to highlight
 * @param searchQuery - The search query to highlight
 * @returns HTML with highlighted matches
 */
export const highlightSearchMatches = (html: string, searchQuery: string): string => {
  if (!searchQuery.trim() || !html) {
    return html;
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const textContent = tempDiv.textContent || tempDiv.innerText || '';

  if (!textContent.toLowerCase().includes(searchQuery.toLowerCase())) {
    return html;
  }

  const regex = new RegExp(`(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

  const highlightedText = textContent.replace(
    regex,
    '<mark style="background-color: #ffeb3b; padding: 0 2px; border-radius: 2px;">$1</mark>'
  );

  return highlightedText;
};

/**
 * Highlights search matches in HTML content while preserving HTML structure
 * @param html - The HTML content to highlight
 * @param searchQuery - The search query to highlight
 * @returns HTML with highlighted matches
 */
export const highlightSearchMatchesInHtml = (html: string, searchQuery: string): string => {
  // Make sure we have a searchQuery and html
  if (!searchQuery || !html) {
    return html;
  }

  const regex = new RegExp(`(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

  const parts = html.split(/(<[^>]*>)/);

  const highlightedParts = parts.map((part) => {
    if (part.startsWith('<') && part.endsWith('>')) {
      return part;
    }

    return part.replace(
      regex,
      '<mark style="background-color: #ffeb3b; padding: 0 2px; border-radius: 2px;">$1</mark>'
    );
  });

  return highlightedParts.join('');
};
